import React from 'react';
import Modal from './modal';
import { Props } from './props';

export default class Portal extends React.Component<Props, {}> {
  render() {
    return this.props.showModal ? <Modal {...this.props} /> : null;
  }
}
